import * as React from 'react';

import { ServiceLocator } from '../../app/ServiceLocator';
import { Messages } from '../../codegen/Localize';
import { TelemetryEvents } from '../../common/telemetryEvents/TelemetryEvents';
import { TelemetryService } from '../../ts/services/TelemetryService';
import { ChannelStyles } from '../styles/ChannelStyles';
import { HomeStyles } from '../styles/HomeStyles';
import { HomeSeeAllClickEvent } from '../telemetry/HomeTelemetryEvents';
import { ChannelTypes } from '../types/ChannelTypes';

interface ChannelHeaderProps {
  readonly channelType: ChannelTypes;
  readonly title: string;
  readonly seeAllUrl?: string;
  readonly seeAllAltText?: string;
}

export class ChannelHeader extends React.PureComponent<ChannelHeaderProps> {

  telemetryService: TelemetryService;

  constructor(props: ChannelHeaderProps) {
    super(props);
    this.telemetryService = ServiceLocator.get<TelemetryService>('TelemetryService');
  }

  private sendTelemetryEvent() {
    this.telemetryService.sendEvent<HomeSeeAllClickEvent>({
      type: TelemetryEvents.HomeSeeAllClick,
      channelType: this.props.channelType
    });
  }

  private mouseUpHandler(event: React.MouseEvent<HTMLAnchorElement>) {
    if(event.button !== 2) {
      this.sendTelemetryEvent();
    }
  }

  private keyPressHandler(event: React.KeyboardEvent<HTMLAnchorElement>) {
    if(event.nativeEvent.key === 'Enter') {
      this.sendTelemetryEvent();
    }
  }

  render() {
    return (
      <header className={ChannelStyles.header}>
        <h2>{this.props.title}</h2>
        {this.props.seeAllUrl &&
          <a
            href={this.props.seeAllUrl}
            className={HomeStyles.link}
            data-tb-test-id="channel-see-all-link"
            aria-label={this.props.seeAllAltText}
            onMouseUp={(e) => this.mouseUpHandler(e)}
            onKeyPress={(e) => this.keyPressHandler(e)}
          >
            {Messages.home_seeAll()}
          </a>
          }
      </header>
    );
  }
}
